



















































































































// import HorizontalBar from "@/components/charts/HorizontalBar.vue";
import Vue from 'vue';
import { LogResultDaily, LogResultTimeRange } from '@/class/models/typed/operation';
import API from '@/api/common';
import { formatYmd, formatYmdhms, makeDateTimeByDateAndHourMinStr } from '@/class/common/util/date_util';
import { PropType } from 'vue';
import RankingPanel from './RankingPanel.vue';
const api = new API();

function secToHM(sec: number): string {
  const totalMin = Math.floor(sec / 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;  
  return `${h}:${String(m).padStart(2, '0')}`;
}

export default Vue.extend({
  name: 'LaborLogResultPanel',
  props: {
    // 親からイベントを渡す想定
    // targetDate: Date,
    targetDate: {
      type: Date as PropType<Date>,
      required: true,
    },
    userId: Number,
    logInTime: String,
    logOutTime: String,
    opCount: Number,
    bannedAppOpCount: Number,
    opTime: String,
    bannedAppOpTime: String,
    opCountInfos: Array,
    opTimeInfos: Array,
    timeRange: {
      type: Object as PropType<{ start: string; end: string }>,
      required: false,
    },
  },

  components: {
    // HorizontalBar, // Chart.jsの代わりにRankingPanrlを使用することにしました。しばらく問題なければChart.jsの処理は削除してください。
    RankingPanel,
  },
  methods: {
    // toggles
    toggleIsDisplayDailyLog(): void {
      this.isDisplayDailyLog = !this.isDisplayDailyLog;
    },
    toggleIsDisplayRangeLog(): void {
      this.isDisplayRangeLog = !this.isDisplayRangeLog;
    },
    // icon text
    getArrowIconText(isDisplay): string {
      return isDisplay ? '▲' : '▼';
    },
    getArrowIconTextDailyLog(): string {
      return this.getArrowIconText(this.isDisplayDailyLog);
    },
    getArrowIconTextRangeLog(): string {
      return this.getArrowIconText(this.isDisplayRangeLog);
    },
    secToHM(sec): string {
      return secToHM(sec);
    },
    async fetchDailyLog() {
      // 1. userId がセットされていない（初期値など）場合は無視
      if (!this.userId || this.userId < 0) {
        return;
      }

      // 2. targetDateがundifinedの場合は無視
      if (!this.targetDate) {
        return;
      }

      // API呼び出し等で日別ログ情報を取得する処理をここに実装
      try {
        this.isLoadingDailyLog = true;

        const formatDate = formatYmd(this.targetDate);
        const param = {
          userId: this.userId,
          targetDate: formatDate,
        } as any;
        const res = await api.get<LogResultDaily>('operation/log_result/daily', param);          
        this.dailyLog = res.data;
        this.formatLoginTime();
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoadingDailyLog = false;
      }
    },
    async fetchRangeLog() {
      // API呼び出し等で時間帯別ログ情報を取得する
      try {
        this.isLoadingRangeLog = true;

        if (!this.timeRange || !this.timeRange.start || !this.timeRange.end) {
          this.resetRangeData();
          return;
        }
        const requestId = ++this.rangeRequestId;
        const startDateTime = formatYmdhms(makeDateTimeByDateAndHourMinStr(this.targetDate, this.timeRange.start));
        const endDateTime = formatYmdhms(makeDateTimeByDateAndHourMinStr(this.targetDate, this.timeRange.end));
        const param = {
          userId: this.userId,
          startDateTime,
          endDateTime,
          opCountLimit: this.maxShowLogData,
          opTimeLimit: this.maxShowLogData,
        } as any;

        const res = await api.get<LogResultTimeRange>('operation/log_result/time_range', param);
        this.timeRangeLog = res.data;

        if (requestId !== this.rangeRequestId) {
          return;
        }

        if (this.timeRangeLog.opTime) {
          this.timeRangeLog.opTime = secToHM(Number(this.timeRangeLog.opTime));
        } else {
          this.timeRangeLog.opTime = '0:00';
        }

        if (this.timeRangeLog.bannedAppOpTime) {
          this.timeRangeLog.bannedAppOpTime = secToHM(Number(this.timeRangeLog.bannedAppOpTime));
        } else {
          this.timeRangeLog.bannedAppOpTime = '0:00';
        }

        if (this.timeRangeLog.opCountInfos) {
          const newLabels = this.timeRangeLog.opCountInfos.map(p => p.appName);
          const newData = this.timeRangeLog.opCountInfos.map(p => p.opCount);
          // 丸ごと入れ替え
          this.chartDataCount = {
            ...this.chartDataCount,
            labels: newLabels,
            datasets: [
              {
                ...this.chartDataCount.datasets[0],
                data: newData,
              },
            ],
          };
        }

        if (this.timeRangeLog.opTimeInfos) {
          const newLabels = this.timeRangeLog.opTimeInfos.map(p => p.appName);

          const seconds = this.timeRangeLog.opTimeInfos.map(p => Number(p.opTime));
          // const newData = seconds.map((sec) => Math.floor(sec / 60)); // Chart.jsの代わりにRankingPanrlを使用することにしました。しばらく問題なければChart.jsの処理は削除してください。
          const newData = seconds;
          const newValue = seconds.map(sec => secToHM(sec));
          this.chartDataTime = {
            ...this.chartDataTime,
            labels: newLabels,
            datasets: [
              {
                ...this.chartDataTime.datasets[0],
                data: newData,
                value: newValue,
              },
            ],
          };
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoadingRangeLog = false;
      }
    },
    onShowDetail() {
      if (!this.userId && !this.targetDate) {
        return;
      }

      let dateValue = formatYmd(this.targetDate);
      let datetoValue = formatYmd(this.targetDate);
      if (this.timeRange && this.timeRange.start && this.timeRange.end) {
        dateValue = formatYmdhms(makeDateTimeByDateAndHourMinStr(this.targetDate, this.timeRange.start));
        datetoValue = formatYmdhms(makeDateTimeByDateAndHourMinStr(this.targetDate, this.timeRange.end));
      }

      const values = {
        setData: String(this.userId),
        date: dateValue,
        dateto: datetoValue,
      } as any;
      this.$emit('showDetail', values);
    },
    formatLoginTime() {
      if (!this.dailyLog || !this.dailyLog.logInTime) {
        return;
      }
      const formatter = new Intl.DateTimeFormat('ja-JP', {
        timeZone: 'Asia/Tokyo',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });

      this.dailyLog.logInTime = formatter.format(new Date(this.dailyLog.logInTime));
      this.dailyLog.logOutTime = formatter.format(new Date(this.dailyLog.logOutTime));
    },
    resetRangeData() {
      this.chartDataCount = {
        labels: [],
        datasets: [
          {
            label: '操作回数',
            backgroundColor: ['#182861', '#00579E', '#0282CB', '#66B0F5', '#9FDEFD'],
            borderColor: null, // 線の色
            borderWidth: 1, // 線の幅
            data: [],
          },
        ],
      } as any;

      this.chartDataTime = {
        labels: [],
        datasets: [
          {
            label: '操作時間',
            backgroundColor: ['#182861', '#00579E', '#0282CB', '#66B0F5', '#9FDEFD'],
            borderColor: null,
            borderWidth: 1,
            data: [],
            value: [],
          },
        ],
        pointBackgroundColor: 'white',
        pointBorderColor: '#249EBF',
        lineTension: 0,
      };
      this.timeRangeLog = {
        opCount: 0,
        bannedAppOpCount: 0,
        opTime: '0:00',
        bannedAppOpTime: '0:00',
        opCountInfos: [],
        opTimeInfos: [],
      } as LogResultTimeRange;
    },
  },
  data() {
    return {
      isLoadingDailyLog: false, // 日次データロード中か？
      isLoadingRangeLog: false, // 選択時間帯データロード中か？
      rangeRequestId: 0,
      maxShowLogData: 1000,
      dailyLog: undefined as LogResultDaily | undefined,
      timeRangeLog: {
        opCount: 0,
        bannedAppOpCount: 0,
        opTime: '0:00',
        bannedAppOpTime: '0:00',
        opCountInfos: [],
        opTimeInfos: [],
      } as LogResultTimeRange,
      caption: {
        capSelectedDateLogInfo: 'この日のログ情報',
        capLogInTime: 'ログオン時間',
        capLogOutTime: 'ログオフ時間',
        capOpCount: '操作回数',
        capBannedAppOpCount: '禁止アプリ操作回数',
        capOpTime: '作業時間',
        capBannedAppOpTime: '禁止アプリ作業時間',
        capMnyOptCountTitle: '操作回数が多いウィンドウタイトル',
        capMnyOptTimeTitle: '操作時間が長いウィンドウタイトル',
      },
      logResult: {
        opCount: 0,
        bannedAppOpCount: 0,
        opTime: '0:00',
        bannedAppOpTime: '0:00',
      },
      isDisplayDailyLog: true,
      isDisplayRangeLog: true,
      chartDataCount: {
        labels: [],
        datasets: [
          {
            label: '操作回数',
            backgroundColor: ['#182861', '#00579E', '#0282CB', '#66B0F5', '#9FDEFD'],
            borderColor: null, // 線の色
            borderWidth: 1, // 線の幅
            data: [],
          },
        ],
      },
      chartDataTime: {
        labels: [],
        datasets: [
          {
            label: '操作時間',
            backgroundColor: ['#182861', '#00579E', '#0282CB', '#66B0F5', '#9FDEFD'],
            borderColor: null, // 線の色
            borderWidth: 1, // 線の幅
            data: [], // グラフで表示する値
            value: [], // 横に表示する値
          },
        ],
        pointBackgroundColor: 'white', // 点の塗りつぶしの色
        pointBorderColor: '#249EBF', // 点の境界線の色
        lineTension: 0, // 線のベジェ曲線の張力。直線を描くには0に設定します
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [
            {
              display: false, // X-axis
              ticks: {
                beginAtZero: true,
                stepSize: 10,
              },
            },
          ],
          yAxes: [
            {
              display: true, // Y-axis
              gridLines: { display: false, drawBorder: true },
              barThickness: 20,
              ticks: {
                font: { size: 12 },
                lineHeight: 1.2,
                callback: value => {
                  return value.split('\n');
                },
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.fetchDailyLog();
  },
  watch: {
    userId() {
      this.fetchDailyLog();
    },

    targetDate() {
      this.fetchDailyLog();
    },
    timeRange: {
      handler() {
        this.fetchRangeLog();
      },
    },
  },
  computed: {
    hasLogData(): boolean {
      return Boolean(this.chartDataTime.labels.length > 0);
    },
  },
});
